import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class ReminderColumn extends Column {
    title = 'employees.onboardingSettings.reminder';
    property = 'name';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
